import css from "styled-jsx/css";
import {
  BACKGROUND_GRAY_COLOR_NAME,
  DARK_WORK_OS_IRIS_COLOR_NAME,
  SPACE_BLUE_COLOR_NAME,
  WHITE_COLOR_NAME
} from "styles/color-consts";
import colors from "styles/colors";
import { MOBILE_QUERY_MIN_WIDTH } from "constants/vp-sizes";

export const componentStyles = css.global`
  .building-blocks-tabs-mobile-component {
    :global(*:focus) {
      outline: none !important;
    }
    .building-blocks-tabs-mobile-navigation {
      overflow-x: auto;
      &::-webkit-scrollbar {
        display: none;
      }
      display: flex;
      gap: 8px;
      padding-left: 16px;
      .tab-nav-button-wrapper {
        font-weight: 500;
        padding: 7px 16px 9px;
        border-radius: 20px;
        background-color: ${colors[BACKGROUND_GRAY_COLOR_NAME]};
        color: ${colors[DARK_WORK_OS_IRIS_COLOR_NAME]};
        white-space: nowrap;
        transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
        &.selected {
          background-color: ${colors[SPACE_BLUE_COLOR_NAME]};
          color: ${colors[WHITE_COLOR_NAME]};
        }
      }
      &::after {
        content: "";
        padding-right: 16px;
      }
    }
    .carousel {
      .slick-slider.focus {
        .slick-list {
          .slick-track {
            padding: 0;
          }
        }
      }
    }
    :global(.secondary-button) {
      :global(.secondary-button-text) {
        font-size: 14px;
      }
      :global(.arrow-wrapper) {
        :global(svg) {
          height: 12px;
          width: 10px;
        }
      }
    }
  }

  @media (min-width: ${MOBILE_QUERY_MIN_WIDTH}) {
    .carousel {
      .slick-slide {
        .side-by-side-text-and-asset {
          .side-by-side-content {
            .full-paragraph-component-wrapper {
              padding: 0;
            }
          }
        }
      }
    }
  }
`;
